import React from 'react';
import { connect } from 'react-redux';
import { setIndexAndCoords } from './../Actions/Booking.action';

const GoogleMapMarker = (props) => {
    const { index, selectedIndex } = props;
    return <div className={`google-map-marker ${selectedIndex === index ? "selected" : ""}`}
        onClick={() => props.setIndexAndCoords(index)}>
        <div className="marker">{index}</div>
    </div>
};

const mapDispatchToProps = dispatch => ({
    setIndexAndCoords: (index) => dispatch(setIndexAndCoords(index))
});
export default connect(null, mapDispatchToProps)(GoogleMapMarker);